<app-panel
  [expanded]="true"
  data-at-active-errors
  *ngIf="activeErrorsStore.isLoading$ | async; else loadedEl"
>
  <app-panel-header>{{ '+INSTALLATIONS.INSTALLATION.STATUS.STATUS' | translate }}</app-panel-header>
  <app-panel-content>
    <vi-loader [isLoading]="true" message="{{ '+GENERAL.LOADING_DATA' | translate }}"></vi-loader>
  </app-panel-content>
</app-panel>

<ng-template #loadedEl>
  <ng-container *ngIf="installationDetailsStore.gatewaySerial$ | async as gatewaySerial">
    <ng-container
      *ngIf="
        activeErrorsStore.getDisplayedActiveErrorsAndNotificationsModel(gatewaySerial, true, false)
          | async as smartNotes
      "
    >
      <app-panel
        data-at-active-errors
        [expandable]="
          smartNotes.countOfAllErrors > 0 ||
          smartNotes.maintenanceNotifications.length > 0 ||
          smartNotes.powerLimitationStatuses.length > 0
        "
        [expanded]="true"
      >
        <app-panel-header>
          <div class="flex flex-row gap-[8px] justify-between items-center">
            <div>{{ '+INSTALLATIONS.INSTALLATION.STATUS.STATUS' | translate }}</div>
            <div
              appPanelText
              *ngIf="
                !smartNotes.countOfAllErrors &&
                !smartNotes.maintenanceNotifications.length &&
                !(burnerErrorStatus$ | async)
              "
            >
              {{ '+INSTALLATIONS.INSTALLATION.STATUS.NO_ERRORS' | translate }}
            </div>
          </div>
        </app-panel-header>
        <app-panel-content
          *ngIf="
            smartNotes.countOfAllErrors ||
            smartNotes.maintenanceNotifications.length > 0 ||
            smartNotes.powerLimitationStatuses.length > 0 ||
            (burnerErrorStatus$ | async | ready)
          "
          class="!flex flex-col gap-[8px]"
        >
          <app-lecture-code-address-panel
            *ngIf="burnerErrorStatus$ | async | ready as feature"
            [feature]="feature"
          ></app-lecture-code-address-panel>
          <app-locked-system-error
            *ngIf="activeErrorsStore.lockedSystemError(gatewaySerial) | async as systemLockedError"
            [systemLockedError]="systemLockedError"
            (navigate)="navigateToErrorDetails($event)"
          >
          </app-locked-system-error>
          <app-floor-heating-over-heating-error
            *ngIf="
              activeErrorsStore.floorHeatingOverHeatingError(gatewaySerial)
                | async as floorHeatingOverHeatingError
            "
            [floorHeatingOverHeatingError]="floorHeatingOverHeatingError"
          >
          </app-floor-heating-over-heating-error>
          <app-power-limitation-statuses
            *ngFor="let powerLimitationStatus of smartNotes.powerLimitationStatuses"
            [powerLimitationStatus]="powerLimitationStatus"
          >
          </app-power-limitation-statuses>
          <app-maintenance-notification
            *ngIf="smartNotes.maintenanceNotifications.length > 0"
            [maintenanceNotifications]="smartNotes.maintenanceNotifications"
          >
          </app-maintenance-notification>

          <app-active-error
            *ngFor="let activeError of smartNotes.displayedErrors"
            [activeError]="activeError"
            [remoteDiagnosticsActiveSessionDeviceSerial]="
              remoteDiagnosticsActiveSessionDeviceSerial
            "
            (navigate)="navigateToErrorDetails($event)"
          ></app-active-error>
          <div class="button-wraper">
            <button
              *ngIf="smartNotes.countOfAllErrors > limitedListMaxLength"
              class="nav-button toggle-button"
              mat-stroked-button
              color="secondary"
              (click)="showMoreActiveErrors()"
            >
              <span class="nav-button-text">
                {{
                  isExpanded
                    ? ('GENERAL.BUTTON.SHOW_LESS' | translate)
                    : ('GENERAL.BUTTON.SHOW_MORE' | translate)
                }}
              </span>
              <mat-icon iconPositionEnd [@arrowRotate]="expandedState">expand_more</mat-icon>
            </button>
          </div>
        </app-panel-content>
      </app-panel>
    </ng-container>
  </ng-container>
</ng-template>
